import Account from "@services/sdk/models/account";
import Order from "@services/sdk/models/order";
import Service from "@services/sdk/models/service";

export interface IActivateState {
	isAccountInitialised?: boolean | null;
	orderType?: string | null;
	isEmailVerified?: boolean | null;
	isActivationInProgress?: boolean | null;
	isActivationCompleted?: boolean | null;
	isActivationFailed?: boolean | null;
	isPrePortInProgress?: boolean | null;
	isPrePortCompleted?: boolean | null;
	isPrePortFailed?: boolean | null;
	isInEmbargo?: boolean | null;
	prePortFailureCount?: number | null;
	isPortingInProgress?: boolean | null;
	isPortingTimedOut?: boolean | null;
	isSimCardScanned?: boolean | null;
	isPlanTypeSelected?: boolean | null;
	isPortingCompleted?: boolean | null;
	isPortingFailed?: boolean | null;
	portingFailureCode?: string | null;
	portFailureCount?: number | null;
	hasProducts?: boolean | null;
	activationNetworkStatus?: string | null;
}

class ActivateState {
	public static ConstructEmpty(): ActivateState {
		return ActivateState.ConstructFromModels(
			Order.ConstructEmpty(),
			Account.ConstructEmpty(),
			Service.ConstructEmpty(),
		);
	}

	public static ConstructFromModels(
		order: Order,
		account: Account,
		service: Service,
	): ActivateState {
		const params = ActivateState.MakeParams(order, account, service);
		return ActivateState.Construct(params);
	}

	public static MakeParams(
		order: Order,
		account: Account,
		service: Service,
	): IActivateState {
		return {
			isAccountInitialised: account.isInitialised,
			orderType: order.orderType,
			isEmailVerified: account.isEmailVerified,
			isActivationInProgress: service.isActivationInProgress,
			isActivationCompleted: service.isActivationCompleted,
			isActivationFailed: service.isActivationFailed,
			isPrePortInProgress: service.isPrePortInProgress,
			isPrePortCompleted: service.isPrePortCompleted,
			isPrePortFailed: service.isPrePortFailed,
			isInEmbargo: service.isInEmbargo,
			prePortFailureCount: service.prePortFailureCount,
			isPortingInProgress: service.isPortingInProgress,
			isPortingTimedOut: service.isPortingTimedOut,
			isPortingCompleted: service.isPortingCompleted,
			isPortingFailed: service.isPortingFailed,
			portingFailureCode: service.portingFailureCode,
			isSimCardScanned: order.isSimCardScanned,
			isPlanTypeSelected: order.isPlanTypeSelected,
			portFailureCount: service.portFailureCount,
			hasProducts: service.hasProducts,
			activationNetworkStatus: service.activationNetworkStatus,
		};
	}

	public static Construct(params: IActivateState): ActivateState {
		return new ActivateState(params);
	}

	isAccountInitialised = false;

	orderType: string | null = null;

	isEmailVerified: boolean | null = null;

	isActivationInProgress: boolean | null = null;

	isActivationCompleted: boolean | null = null;

	isActivationFailed: boolean | null = null;

	isPrePortInProgress: boolean | null = null;

	isPrePortCompleted: boolean | null = null;

	isPrePortFailed: boolean | null = null;

	isInEmbargo: boolean | null = null;

	prePortFailureCount: number | null = null;

	isPortingInProgress: boolean | null = null;

	isPortingTimedOut: boolean | null = null;

	isPortingCompleted: boolean | null = null;

	isPortingFailed: boolean | null = null;

	portingFailureCode: string | null = null;

	isPlanTypeSelected: boolean | null = null;

	isSimCardScanned: boolean | null = null;

	portFailureCount: number | null = null;

	hasProducts: boolean | null = null;

	activationNetworkStatus?: string | null;

	private constructor(params?: IActivateState) {
		if (!params) {
			return;
		}

		Object.assign(this, params);
	}

	public update(params: IActivateState): ActivateState {
		const updatedActivateState = ActivateState.Construct({ ...this });
		Object.assign(updatedActivateState, params);

		return updatedActivateState;
	}
}

export default ActivateState;
